import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Button as Btn, Typography } from "@material-ui/core";
import { Spinner } from "../../../components";
import { useSearchParams } from "react-router-dom";
import { PrimaryColor } from "../../../shared/styles/colors";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import Team from "../../../model/team";
import TeamModal from "./TeamModal";
import DateConverter from "../../../utils/DateConverter";
import useStyles from "./styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import DatabaseEntities from "../../../model/enum/DatabaseEntities";
import ApiService from "../../../service/ApiService";
import Employee from "../../../model/employee";
import EmployeeRole from "../../../model/employeeRole";
import Misc from "../../../utils/Misc";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  team: Team;
  employees: Employee[];
  roles: EmployeeRole[];
  resetList?: () => void;
  onOpen?: (id?: string) => void;
  onClose?: () => void;
}

type Member = {
  id: number;
  employeeId: number;
  employeeRoleId: number;
  Employee: Employee;
  EmployeeRole: EmployeeRole;
};

const TeamDetailModal = ({
  team,
  employees,
  roles,
  resetList,
  onOpen,
  onClose,
}: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [members, setMembers] = useState<Member[]>([]);
  const [loading, setLoading] = useState(true);

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) {
      onOpen(team.id?.toString());
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    const teamId = searchParams.get("teamId");
    if (!open && teamId && teamId === team.id?.toString()) {
      handleOpen();
    }
  }, [searchParams]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await ApiService.get<Member[]>(
        `${DatabaseEntities.TEAMS}/${team.id}/${DatabaseEntities.TEAM_MEMBERS}`
      ).then((data: Member[]) => {
        if (Misc.isArrayEmpty(data)) return;
        setMembers(data);
      });
      setLoading(false);
    };

    if (open && Misc.isArrayEmpty(members)) {
      fetchData();
    }
  }, [open, members]);

  //TODO: rating

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor}}/>
      </Button>
      {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ overflowY: "auto" }}
        >
          <Box sx={style}>
            {loading && <Spinner />}
            <div className={classes.headerDiv}>
              <div className={classes.headerSubDiv2}>
                <Typography className={classes.title}>Team</Typography>
                <div className="vl" style={{ marginLeft: "1rem" }}></div>
                <Typography
                  className={classes.subtitle}
                  style={{ marginLeft: "1rem" }}
                >
                  Info
                </Typography>
              </div>
              <div className={classes.headerSubDiv}>
                <TeamModal
                  team={team}
                  teamMembers={members}
                  employees={employees}
                  roles={roles}
                  resetList={resetList}
                />
                <Button onClick={handleClose} sx={{ color: "black" }}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
            <hr />
            <div className={classes.form}>
              <Typography className={classes.bigTitle}>{team.name}</Typography>
              <div className={classes.detailDiv}>
                <div className={classes.detailSubDiv}>
                  <Typography className={classes.subtitle}>
                    {team.description}
                  </Typography>
                </div>
                <div className={classes.detailSubDiv}>
                  <div className={classes.detailSubDiv2}>
                    <Btn className={classes.button2} disabled>
                      <WorkOutlineIcon />
                      {team.User &&
                        `${team.User.firstName} ${team.User.lastName}`}
                    </Btn>
                    {/* <div className={classes.rating}>
                      {[...Array(5)].map((_, index) => (
                        <span
                          key={index}
                          className={
                            index < Math.round(team?.Project?.rate)
                              ? classes.filledStar
                              : classes.emptyStar
                          }
                        >
                          ★
                        </span>
                      ))}
                    </div> */}
                  </div>
                  <div className={classes.inputDiv}>
                    <input
                      className={classes.inputDetail}
                      value={DateConverter.toMonthNameDateAndYear(
                        team.createdAt
                      )}
                      disabled
                    />
                    {/* <span className={classes.icon}>
                    <CalendarMonthIcon />
                  </span> */}
                  </div>
                </div>
              </div>
              <div>
                <div className={classes.headerSubDiv2}>
                  <Typography>Employees</Typography>
                </div>
                <div>
                  {members &&
                    members.map((member: any) => (
                      <div className={classes.detailSubDiv2}>
                        <Typography className={classes.inputDetail}>
                          {`${member.Employee.firstName} ${member.Employee.lastName}`}
                        </Typography>
                        <Typography className={classes.inputDetail}>
                          {member.EmployeeRole.name}
                        </Typography>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default TeamDetailModal;
